module.exports = __webpack_public_path__ + "static/media/facebook-icon.f4fd696f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facebook-icon.svg
// module id = 225
// module chunks = 0